export default [
  {
    title: "Báo cáo",
    icon: { icon: "tabler-report" },
    permissionIds: [78, 81, 82],
    children: [
      {
        title: "BC lượt tiếp cận",
        to: { name: "report-ads-report", meta: { permissionId: 78 } },
      },
      {
        title: "FnetPro",
        permissionIds: [81, 82],
        children: [
          {
            title: "Tổng quan",
            to: { name: "fnetpro-dashboard", meta: { permissionId: 81 } },
          },
          {
            title: "Chi tiết",
            to: { name: "fnetpro-detail-report", meta: { permissionId: 82 } },
          },
        ],
      },
    ],
  },
];
